/** True only when the Next.js / Node runtime is in development mode. */
export const isDevelopment = process.env.NODE_ENV === 'development';

/** True for production builds (`next build` / `next start`). */
export const isProduction = process.env.NODE_ENV === 'production';
